import * as React from 'react';
import { observer, inject } from "mobx-react";
import history from '../history';
import { Button, FormControl, Select, MenuItem } from '@material-ui/core';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import EditIcon from '@material-ui/icons/Edit';
import CancelIcon from '@material-ui/icons/Cancel';

// =====================================
// CONSTS
import { ProductNotes } from '../../const/ProductNotes';

// =====================================
// STORES
import { IOrdersStore } from '../../store/OrdersStore';

// =====================================
// COMPONENTS
import { Header } from '../Layout/Header';


@inject((allStores: any) => ({
    ordersStore: allStores.store.ordersStore as IOrdersStore
}))

@observer
export default class NewOrderArticles extends React.Component<{ ordersStore?: IOrdersStore; customerId?: any }, {}> {

    redirectToArticles = () => {
        history.push(`/articles/${this.props.customerId}/${this.props.ordersStore.isEditOrder}/${this.props.ordersStore.order.id}`);
    }

    renderIconNote = (note) => {
        let iconNoteComponent: any = null;

        if(note === ProductNotes.added) {
            iconNoteComponent = <AddCircleIcon className="note-icon add-note"/>;
        } else if (note === ProductNotes.modified)  {
            iconNoteComponent = <EditIcon className="note-icon edit-note"/>;
        } else if (note === ProductNotes.canceled)  {
            iconNoteComponent = <CancelIcon className="note-icon cancel-note"/>;
        } else {
            iconNoteComponent = null;
        }

        return iconNoteComponent
    }

    render() {
        let locationComponent: any = null;
        if (this.props.ordersStore.customer.locations !== null) {
            locationComponent = <div className="new-order-header">
                <FormControl component="fieldset" className="full-width">
                    <div className="bold-text">Lokacija</div>
                    <Select
                        value={this.props.ordersStore.locationCode}
                        onChange={this.props.ordersStore.handleChangeLocation}
                    >
                        {this.props.ordersStore.locations.map((item, i) => {
                            return <MenuItem value={item.externalReferenceCode} key={i}>{item.name}</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>
        }

        return (
            <div className="new-order">
                <Header
                    title='Nova porudžbina'
                    isBackButtonVisible={true}
                    url={`/orders/${this.props.customerId}`} />

                <div className="container">
                    <div className="new-order-header">
                        <div>Dodati omiljene proizvode klikom na dugme  <AddCircleIcon fontSize="small" className="add-icon" /></div>
                        <div>Obeležite proizvode klikom na <StarBorderIcon fontSize="small" className="star-icon" /></div>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            className="add-btn"
                            onClick={this.redirectToArticles}
                            startIcon={<AddCircleIcon />}
                        >Dodati proizvode
                        </Button>
                    </div>

                    {locationComponent}

                    {this.props.ordersStore.productsForOrder.map((product, i) => {
                        return <div className="order-container" key={i}>
                            <div className="product">
                                <div className="product-center-row">
                                    <div className={`${product.note === ProductNotes.replaced ? "product-name product-name-strike" : "product-name"}`}>{product.name} - {product.unitOfMeasurement}</div>
                                    <div>
                                        {this.renderIconNote(product.note)}
                                    </div>
                                </div>
                                <div className="product-row">
                                    <div>Šifra: {product.code}</div>

                                    <div className="product-row">
                                        <RemoveIcon
                                            onClick={() => { this.props.ordersStore.decreaseAmount(product) }}
                                            className={`${product.note === ProductNotes.replaced ? "remove-icon disable-icon" : "remove-icon"}`} />

                                        {/* <span className="requested-amount">{product.productOrderedAmount}</span> */}
                                        <input className="requested-amount"
                                            type="number"
                                            inputMode="numeric"
                                            name={product.id}
                                            readOnly={product.isReadOnly}
                                            disabled={product.note === ProductNotes.replaced}
                                            value={product.productOrderedAmount.toString()}
                                            onDoubleClick={this.props.ordersStore.enableRequestedAmountInput}
                                            onChange={this.props.ordersStore.handleRequestedAmount(product)} />
                                        <AddIcon
                                            onClick={() => { this.props.ordersStore.increaseAmount(product) }}
                                            className={`${product.note === ProductNotes.replaced ? "add-icon disable-icon" : "add-icon"}`} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    })}

                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        className="save-btn"
                        onClick={this.props.ordersStore.goToOrderDetails}
                        endIcon={<ArrowForwardIcon />}
                    >Dalje
                    </Button>
                </div>
            </div>
        );
    }
}